/* unplugin-vue-components disabled */import __unplugin_components_3 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import __unplugin_components_2 from '/var/repos/bic-vue/src/components/configurator/FabricCanvas.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/configurator/2dEditor/PrintSideLabel.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/topbar/EditorToolbar.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex flex-col h-full"
};
const _hoisted_2 = {
  class: "flex-1 overflow-hidden relative"
};
const _hoisted_3 = {
  key: 0,
  class: "side-label flex justify-center text-center mb-5 px-2 text-white rounded-md select-none pointer-events-none"
};
const _hoisted_4 = {
  key: 1,
  class: "canvasSpacer p-6 pointer-events-none"
};
const _hoisted_5 = {
  key: 2,
  class: "side-label text-center mb-5 px-2 text-white rounded-md select-none pointer-events-none"
};
const _hoisted_6 = {
  class: "absolute bottom-6 right-10 flex gap-2"
};
import Workspace from '@/components/configurator/Workspace';
import ButtonGroup from '@/components/common/button/ButtonGroup';
import EditorButton from '@/components/common/button/EditorButton';
import { useConfiguratorStore } from '@/stores/configurator';
import { useConfigurationStore } from '@/stores/configurationModule';
import useEditorEventListeners from '@/composables/2dEditor/useEditorEventListeners';
export default {
  __name: 'Editor2d',
  props: {
    width: {
      require: true,
      type: Number,
      default: 6
    },
    length: {
      require: true,
      type: Number,
      default: 6
    },
    depth: {
      require: true,
      type: Number,
      default: 6
    },
    type: {
      require: true,
      type: String,
      default: 'Shipping'
    }
  },
  setup(__props) {
    const $eventBus = inject('bus');
    const configuratorStore = useConfiguratorStore();
    const {
      isEditorFullscreen,
      zoomInEnabled,
      zoomOutEnabled,
      canvasContainerScale
    } = storeToRefs(configuratorStore);
    const configurationStore = useConfigurationStore();
    const {
      hasInsidePrinting,
      activeCanvas,
      fabricCanvases,
      isActivePanelInside
    } = storeToRefs(configurationStore);
    const props = __props;
    const canvasContainerRef = ref(null);
    function centerCanvasContainerInWorkspace() {
      const oneHalf = 1 / 2; // Default position multiplier
      const oneForth = 1 / 4; // Default position multiplier when inside printing is enabled (for outside printing canvas)
      const threeFourths = 3 / 4; // Default position multiplier when inside printing is enabled (for inside printing canvas)

      const fineOffset = 1 / 20; // Used to fine-tune the position of the canvas container so that both sides are visible

      const insideCanvasPosition = threeFourths - fineOffset;
      const outsideCanvasPosition = oneForth + fineOffset;
      const verticalPositionMultiplier = hasInsidePrinting.value ? isActivePanelInside.value ? insideCanvasPosition : outsideCanvasPosition : oneHalf;
      const horizontalPositionMultiplier = oneHalf;
      const topOffset = canvasContainerRef.value.offsetHeight * verticalPositionMultiplier;
      const leftOffset = canvasContainerRef.value.offsetWidth * horizontalPositionMultiplier;
      canvasContainerRef.value.style.setProperty('top', `calc(50% - ${topOffset}px)`);
      canvasContainerRef.value.style.setProperty('left', `calc(50% - ${leftOffset}px)`);
      $eventBus.$emit('reset-zoom');
    }
    function handleScroll(event) {
      if (event.ctrlKey || event.altKey || event.metaKey) {
        if (event.deltaY > 0) {
          $eventBus.$emit('zoom-out');
        } else if (event.deltaY < 0) {
          $eventBus.$emit('zoom-in');
        }
      } else {
        if (event.shiftKey) {
          $eventBus.$emit('scroll-movement-h', event);
        } else {
          $eventBus.$emit('scroll-movement', event);
        }
      }
    }
    onMounted(() => {
      useEditorEventListeners();
      centerCanvasContainerInWorkspace();
      $eventBus.$on('center-in-workspace', centerCanvasContainerInWorkspace);
    });
    return (_ctx, _cache) => {
      const _component_EditorToolbar = __unplugin_components_0;
      const _component_PrintSideLabel = __unplugin_components_1;
      const _component_FabricCanvas = __unplugin_components_2;
      const _component_SvgIcon = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_EditorToolbar, {
        class: "relative z-10"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(Workspace), {
        onWheel: handleScroll
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "canvas-container absolute m-0 will-change-[top,left]",
          style: _normalizeStyle({
            transform: `scale(${_unref(canvasContainerScale)})`
          }),
          ref_key: "canvasContainerRef",
          ref: canvasContainerRef
        }, [_unref(hasInsidePrinting) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_PrintSideLabel, {
          isActive: _unref(activeCanvas) === _unref(fabricCanvases)[0]
        }, {
          default: _withCtx(() => [_createTextVNode(" Outside ")]),
          _: 1
        }, 8, ["isActive"])])) : _createCommentVNode("", true), _createVNode(_component_FabricCanvas, {
          name: "outsidePrintingCanvas",
          width: props.width,
          length: props.length,
          depth: props.depth,
          type: props.type,
          "print-side": "outside"
        }, null, 8, ["width", "length", "depth", "type"]), _unref(hasInsidePrinting) ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true), _unref(hasInsidePrinting) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_PrintSideLabel, {
          isActive: _unref(activeCanvas) === _unref(fabricCanvases)[1]
        }, {
          default: _withCtx(() => [_createTextVNode(" Inside ")]),
          _: 1
        }, 8, ["isActive"])])) : _createCommentVNode("", true), _unref(hasInsidePrinting) ? (_openBlock(), _createBlock(_component_FabricCanvas, {
          key: 3,
          name: "insidePrintingCanvas",
          width: props.width,
          length: props.length,
          depth: props.depth,
          type: props.type,
          "print-side": "inside"
        }, null, 8, ["width", "length", "depth", "type"])) : _createCommentVNode("", true)], 4)]),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ButtonGroup), null, {
        default: _withCtx(() => [_createVNode(_unref(EditorButton), {
          class: _normalizeClass([{
            'btn-disabled': !_unref(zoomOutEnabled)
          }, "!cursor-pointer pointer-events-auto"]),
          id: "zoom-out",
          join: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref($eventBus).$emit('zoom-out'))
        }, {
          default: _withCtx(() => [_createVNode(_component_SvgIcon, {
            class: "w-[24px] h-[24px]",
            fill: "white",
            svgSymbolId: "minus"
          })]),
          _: 1
        }, 8, ["class"]), _createVNode(_unref(EditorButton), {
          class: _normalizeClass([{
            'btn-disabled': !_unref(zoomInEnabled)
          }, "!cursor-pointer pointer-events-auto"]),
          id: "zoom-in",
          join: "",
          onClick: _cache[1] || (_cache[1] = $event => _unref($eventBus).$emit('zoom-in'))
        }, {
          default: _withCtx(() => [_createVNode(_component_SvgIcon, {
            class: "w-[24px] h-[24px]",
            fill: "white",
            svgSymbolId: "plus"
          })]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      }), _createVNode(_unref(ButtonGroup), null, {
        default: _withCtx(() => [_createVNode(_unref(EditorButton), {
          id: "center-in-workspace",
          onClick: _cache[2] || (_cache[2] = $event => _unref($eventBus).$emit('center-in-workspace'))
        }, {
          default: _withCtx(() => [_createVNode(_component_SvgIcon, {
            class: "w-[24px] h-[24px]",
            fill: "white",
            svgSymbolId: "recenter"
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ButtonGroup), null, {
        default: _withCtx(() => [_createVNode(_unref(EditorButton), {
          id: "fullscreen",
          tooltip: _unref(isEditorFullscreen) ? 'Contract Workspace' : 'Expand Workspace',
          onClick: _cache[3] || (_cache[3] = $event => _unref($eventBus).$emit('editor-fullscreen'))
        }, {
          default: _withCtx(() => [_createVNode(_component_SvgIcon, {
            class: "w-[24px] h-[24px]",
            fill: "white",
            svgSymbolId: "fullscreen"
          })]),
          _: 1
        }, 8, ["tooltip"])]),
        _: 1
      })])])]);
    };
  }
};